<template>
    <div id="menu" v-bind:class="{ active :  menuStatus}">
        <div class="row">
            <div class="col-sm-12">
                <p class="h1 artwork-title text-center">JOYFULLY WAITING</p>
            </div>
            <div class="col-sm-12">
                <p class="h1 artwork-title text-center" style="margin-top: 2.5vh;">EDITIONS</p>
                <div v-if="data" class="number-editions text-center text-wrap">
                    <div v-for="(item, key) in data" :key="'i_'+key">
                        <router-link :to="item.post_name">
                            <p class="h1 artwork-title text-center" v-if="item.acf.number" v-html="item.acf.number" :style="'color:'+ item.acf.color"></p>
                        </router-link>
                    </div>
                </div>
                <p class="h1 artwork-title text-center" @click="close">
                    <router-link to="/echoes" style="margin-top: 2.5vh; color: #555;">ECHOES</router-link>
                </p>
                <p class="h1 artwork-title text-center" @click="close">
                    <router-link to="/artists" style="margin-top: 2.5vh; color: #555;">ARTISTS</router-link>
                </p>
                <p class="h1 artwork-title text-center" @click="close">
                    <router-link to="/about" style="margin-top: 2.5vh; color: #555;">ABOUT</router-link>
                </p>
                <p class="h1 artwork-title text-center">
                    <!--@click="close"-->
                    <!-- <router-link to="/support-us" style="margin-top: 2.5vh; color: #555;">SUPPORT US</router-link> -->
                    <a href="https://support-us.joyfully-waiting.ch/" style="margin-top: 2.5vh; color: #555;">SUPPORT US</a>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';


export default {
    props: ['data'],
    data() {
        return {

        }
    },
    components: {},
    computed: {
        query() {
            return this.$route.query.id
        },
        menuStatus() {
            return this.$store.state.menuStatus;
        }
    },
    mounted() {},
    methods: {
        close() {
            this.$store.commit('setMenuStatus', false)
        }
    },
    watch: {}

}
</script>